import { styled } from '@pata-app/themes';

interface FeatureTileContainerProps {
  $alignment: 'left' | 'right;';
}

export const FeatureTilesContainer = styled.div`
  display: grid;
  width: 100%;
  gap: ${({ theme }) => theme.core.sizing[5]}px;

  grid-template-columns: auto;
  column-gap: ${({ theme }) => theme.core.sizing[5]}px;

  margin: 100px auto;

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    grid-template-columns: repeat(auto-fit, minmax(500px, 48%));
  }
`;

export const FeatureTileContainer = styled.div<FeatureTileContainerProps>`
  gap: ${({ theme }) => theme.core.sizing[3]}px;
  width: 100%;
  min-height: 500px;

  border: 0.5px solid ${({ theme }) => theme.core.colors.greyscale.dark};
  border-right: 10px solid ${({ $color }) => $color};
  border-radius: ${({ theme }) => theme.core.border.container.radius}px;

  background: ${({ theme }) => theme.core.colors.greyscale.white};

  > svg {
    height: 45px;
    width: 45px;

    fill: ${({ theme }) => theme.core.colors.primary.green.medium};
  }

  img {
    max-height: 150px;
    max-width: 100%;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.xs}`} {
    min-height: 500px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.m}`} {
    flex-direction: row;
    min-height: 650px;

    border-top: 0.5px solid ${({ theme }) => theme.core.colors.primary.green.medium};
    /* border-${({ $alignment }) => $alignment}: 8px solid ${({ theme }) => theme.core.colors.primary.green.medium}; */

    margin: 0 20px;

    img {
      width: 150px;
      height: 150px;
      max-width: initial;

      object-fit: contain;
    }

    > svg {
      width: 45px;
      flex-shrink: 0;

      fill: ${({ theme }) => theme.core.colors.primary.green.medium};
    }
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    min-height: 500px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.xxl}`} {
    min-height: 350px;
  }
`;

export const FeatureTileContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[0]}px;

  strong {
    font-size: ${({ theme }) => theme.core.fontSizes.l}px;
  }

  h3 {
    color: ${({ theme }) => theme.core.colors.primary.green.medium};

    margin: 0;

    font-size: ${({ theme }) => theme.core.fontSizes.xl}px;
  }

  p {
    margin: 0;

    &:first-of-type {
      margin-top: ${({ theme }) => theme.core.sizing[1]}px;
    }
  }
`;

export const FeatureHighlight = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  > div:first-of-type {
    width: min-content;
  }
  > div:last-of-type {
    display: flex;
    flex-direction: column;
  }
`;

export const MessageCount = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.core.sizing[0]}px;

  span {
    font-weight: ${({ theme }) => theme.core.fontWeight.semiBold};

    &:first-of-type {
      font-size: ${({ theme }) => theme.core.fontSizes.xl}px;
    }
    &:last-of-type {
      font-size: ${({ theme }) => theme.core.fontSizes.l}px;
    }
  }
`;

export const PercentageContainer = styled.div`
  font-weight: ${({ theme }) => theme.core.fontWeight.semiBold};
  font-size: ${({ theme }) => theme.core.fontSizes.xxxl}px;
`;

export const LogoContainer = styled.div``;
